<template>
	<div
		class="banner-announcement-item ask-for-notifications"
		data-name="notification"
	>
		<img
			src="/images/pronto/notifications-bell.svg"
			:alt="$t('common_notification_label')"
		/>
		<div class="ask-for-notification-content-wrapper">
			<span class="ask-for-notifications-heading">{{
				$t('announcements_enable_desktop_notifications')
			}}</span>
			<div
				class="ask-for-notification-content notification-suggest line-clamp-1"
			>
				{{ $t('notification_banner_desc') }}
			</div>
			<div class="permission-reminder-controls">
				<div @click="dismissNotification('session')" class="notification-link">
					{{ $t('notification_banner_ask_me_later') }}
				</div>
				<div class="dot">&middot;</div>
				<div @click="dismissNotification()" class="notification-link">
					{{ $t('notification_banner_never_ask_again') }}
				</div>
				<button class="enable-text" @click="enableNotifications">
					{{ $t('notification_banner_enable') }}
				</button>
			</div>
		</div>
		<CloseIcon class="dismiss-btn" @click.stop="dismiss($event)" />
	</div>
</template>

<script>
import store from '@/store'
import { CloseIcon } from '@/icons'
export default {
	components: { CloseIcon },
	data() {
		return {
			store,
		}
	},
	emits: ['close'],
	methods: {
		dismiss(event) {
			this.$emit('close', event)
		},

		dismissNotification(duration) {
			duration === 'session'
				? sessionStorage.setItem('hideNotificationPrompt', true)
				: localStorage.setItem('hideNotificationPrompt', true)
			this.store.askForNotificationPermission = false
		},

		enableNotifications() {
			EventBus.$emit('enableNotifications')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.ask-for-notification-content-wrapper {
	color: #ffffff;
	font-size: 17px;
	font-family: map-get($fonts, 900);
}

.ask-for-notifications-heading {
	opacity: 0.7;
	font-size: 12px;
}

.ask-for-notifications {
	font-family: Avenir-Roman;
	font-size: 17px;
	color: #ffffff;
	@include flex(16px);
	display: flex !important;

	.dismiss-btn {
		cursor: pointer;
		color: white;
		font-size: 18px;
		position: absolute;
		top: 12px;
		right: 12px;
		&:hover {
			color: var(--blue-100);
		}
	}
}

.ask-for-notification-content {
	position: unset !important;
}

.enable-text {
	border-radius: 4px;
	background-color: #ffffff;
	opacity: 1;
	font-size: 12px;
	color: var(--blue-300);
	position: absolute;
	right: 16px;
	bottom: 11px;
}

.permission-reminder-controls {
	display: flex;
	.notification-link {
		font-family: map-get($fonts, 500);
		font-size: 14px;
		text-decoration: underline;
		cursor: pointer;
	}
}

.notification-suggest {
	font-family: map-get($fonts, 900);
	font-size: 15px;
	margin: 4px 0 4px 0;
}

.dot {
	font-size: 35px;
	line-height: 20px;
	margin-right: 10px;
	margin-left: 10px;
}
</style>
